var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dataScreenBox"},[_c('span',{staticClass:"dataScreenSpan"},[_vm._v(_vm._s(_vm.dateText))]),_c('span',{staticClass:"dataScreenSpan",staticStyle:{"margin":"0 15px"}},[_vm._v(_vm._s(_vm.timeText))]),_c('span',{staticClass:"dataScreenSpan"},[_vm._v(_vm._s(_vm.weekText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }